import { USER } from '../constant/actionTypes';

const getRoleList = () => (dispatch) => {
  dispatch({
    payload: [],
    type: USER.ROLE.INITIATE,
  });

  const userRole = [{
    active: 1,
    id: 1,
    roleName: 'godadmin',
  }, {
    active: 1,
    id: 2,
    roleName: 'admin',
  },
  {
    active: 1,
    id: 4,
    roleName: 'developer',
  }];
  dispatch({
    payload: userRole,
    type: USER.ROLE.SUCCESS,
  });
};

export default getRoleList;
